var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("collapsible-card", {
    attrs: {
      "collapse-id": "referrer-linked-applications",
      "store-path": "referrerLinkedApplications",
    },
    scopedSlots: _vm._u([
      {
        key: "header",
        fn: function () {
          return [
            _c("span", [
              _vm._v(
                "\n      " +
                  _vm._s(_vm.$t("referrers.messages.applicationsAssociated")) +
                  "\n    "
              ),
            ]),
          ]
        },
        proxy: true,
      },
      {
        key: "body",
        fn: function () {
          return [
            _vm.loading
              ? _c("referrer-linked-apps-loader")
              : !_vm.isEmpty
              ? _c(
                  "b-row",
                  _vm._l(_vm.applications, function (ref) {
                    var clientApplicationId = ref.clientApplicationId
                    var filogixId = ref.filogixId
                    var username = ref.username
                    var givenName = ref.givenName
                    var agentUsername = ref.agentUsername
                    var familyName = ref.familyName
                    var email = ref.email
                    var applicationStatus = ref.applicationStatus
                    var applicationType = ref.applicationType
                    var profilePhoto = ref.profilePhoto
                    var photoVersion = ref.photoVersion
                    return _c(
                      "b-col",
                      {
                        key: clientApplicationId,
                        staticClass: "pb-3",
                        attrs: { cols: "12" },
                      },
                      [
                        _c(
                          "b-row",
                          [
                            _c(
                              "b-col",
                              { attrs: { cols: "12" } },
                              [
                                _c(
                                  "router-link",
                                  {
                                    staticClass:
                                      "text-primary bold btn-view-app mr-1",
                                    attrs: {
                                      to: _vm.getApplicationLink(
                                        username,
                                        agentUsername,
                                        clientApplicationId
                                      ),
                                    },
                                  },
                                  [
                                    _c("span", [
                                      _vm._v(
                                        "\n                " +
                                          _vm._s(
                                            _vm.$t("application.applicationID")
                                          ) +
                                          ":\n                " +
                                          _vm._s(clientApplicationId) +
                                          "\n                "
                                      ),
                                      filogixId
                                        ? _c("span", [
                                            _vm._v(
                                              "\n                  " +
                                                _vm._s(filogixId) +
                                                "\n                "
                                            ),
                                          ])
                                        : _vm._e(),
                                    ]),
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "b-badge",
                                  {
                                    staticClass: "ml-0",
                                    style: {
                                      "background-color":
                                        _vm.$options.filters.getSecondaryComplement(),
                                    },
                                  },
                                  [
                                    _c("span", { staticClass: "small" }, [
                                      _vm._v(
                                        "\n                " +
                                          _vm._s(
                                            _vm.applicationTypeText(
                                              applicationType
                                            )
                                          ) +
                                          "\n              "
                                      ),
                                    ]),
                                  ]
                                ),
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c("b-col", { attrs: { cols: "12" } }, [
                              _c(
                                "p",
                                {
                                  staticClass:
                                    "small text-gray mb-0 regular-line-height",
                                },
                                [
                                  _c(
                                    "span",
                                    { staticClass: "bold capitalize" },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$tc("global.words.email", 1)
                                        ) + ":"
                                      ),
                                    ]
                                  ),
                                  _vm._v(
                                    "\n              " +
                                      _vm._s(email) +
                                      "\n            "
                                  ),
                                ]
                              ),
                            ]),
                            _vm._v(" "),
                            _c("b-col", { attrs: { cols: "12" } }, [
                              _c(
                                "p",
                                {
                                  staticClass:
                                    "small text-gray mb-0 regular-line-height",
                                },
                                [
                                  _c("span", { staticClass: "bold" }, [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$t(
                                          "direct-to-lender.lenderSubmit.applicationStatus"
                                        )
                                      ) + ":"
                                    ),
                                  ]),
                                  _vm._v(
                                    "\n              " +
                                      _vm._s(
                                        _vm.statusText(applicationStatus)
                                      ) +
                                      "\n            "
                                  ),
                                ]
                              ),
                            ]),
                            _vm._v(" "),
                            _c(
                              "b-col",
                              {
                                staticClass: "d-flex mt-1 align-items-center",
                                attrs: { cols: "12" },
                              },
                              [
                                _c(
                                  "profile-avatar",
                                  _vm._b(
                                    {
                                      staticClass: "small client-avatar mr-2",
                                      staticStyle: {
                                        width: "1.7rem",
                                        height: "1.7rem",
                                      },
                                    },
                                    "profile-avatar",
                                    {
                                      familyName: familyName,
                                      givenName: givenName,
                                      username: username,
                                      profilePhoto: profilePhoto,
                                      photoVersion: photoVersion,
                                    },
                                    false
                                  )
                                ),
                                _vm._v(" "),
                                _c(
                                  "p",
                                  {
                                    staticClass: "mb-0 text-gray capitalize",
                                    staticStyle: { "font-size": "0.9rem" },
                                  },
                                  [
                                    _vm._v(
                                      "\n              " +
                                        _vm._s(
                                          _vm._f("fullName")({
                                            givenName: givenName,
                                            familyName: familyName,
                                          })
                                        ) +
                                        "\n            "
                                    ),
                                  ]
                                ),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    )
                  }),
                  1
                )
              : _c(
                  "b-row",
                  { staticClass: "justify-content-center" },
                  [
                    _c(
                      "no-results",
                      {
                        attrs: {
                          "img-src": require("@Broker/@Assets/icon/empty-timeline.png"),
                        },
                      },
                      [
                        _vm._v(
                          "\n        " +
                            _vm._s(
                              _vm.$t(
                                "referrers.messages.thereAreNoApplications"
                              )
                            ) +
                            "\n      "
                        ),
                      ]
                    ),
                  ],
                  1
                ),
          ]
        },
        proxy: true,
      },
    ]),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }